// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__15Mcd","icon":"style_icon__GkeWa","setIcon":"style_setIcon__1Nic_","setIconActive":"style_setIconActive__3GLf5","link":"style_link__iQ_Ro"};